module.exports = "<ion-nav-view name=\"tab-assets-tasks\"></ion-nav-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/controllers/assets-tabs.html
// module id = 3085
// module chunks = 0